module.exports = __webpack_public_path__ + "static/rydbergs-444f918114d59f22fe6f053d32ea9ba0.png";